import type { FaireProductEntity } from "../../entity_types/product";

export const p_2s7vj8ewmv: FaireProductEntity = {
  token: "p_2s7vj8ewmv",
  type: "product",
  name: "Chunky Matte Beaded Collar Necklace Jewelry",
  brandToken: "b_c13u0h5ncv",
  brandName: "ZENZII Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/b6dbd5db82401e828fc9a67b1903ae31ef093fbdc2a37fcd9b1ad73462cf72f0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/45e635490f52a97e58c9fe9e982a1a200ff556b1514d939c1acc8207dcf4d440.jpeg",
    "https://cdn.faire.com/fastly/cedd1bd7ad0c63288f5acfb399e927c80e722b37895588d83149771bb78a0822.jpeg",
    "https://cdn.faire.com/fastly/d2e17c956a4bec214f23b5b8db3bf655a59749922e692b1a01b0607824054631.jpeg",
    "https://cdn.faire.com/fastly/0f0d04445b1d34adf86f02babc1231358a395a9b39bf354e39b9dee1c1505e74.jpeg",
    "https://cdn.faire.com/fastly/8abeadefbfdc16e7dfaf9358b026a1533f4116b5c800fb27d4bd2e7c67a45c0f.jpeg",
    "https://cdn.faire.com/fastly/14591616c951ed458b97911d71698ee8aa1be7a768fc5574a9b7cd15830b583b.jpeg",
    "https://cdn.faire.com/fastly/1b088580dcaf3c7446a64b23c3abc1b59e608444896be0b320b615fc59725a06.jpeg",
    "https://cdn.faire.com/fastly/4a7644392e6d14ac8a14b7aa7df03bf8350ba3639117cf3ffd4cf2915d078f46.jpeg",
    "https://cdn.faire.com/fastly/2c7d4e464d5836c42bcf9610194a3bdf5891f2ed65f94cf1dbb8e4d44c1af05f.jpeg",
    "https://cdn.faire.com/fastly/be142dbd2695db8c33b3f987fa11a60045aa1df6128214821c1538b9ebb684f9.jpeg",
  ],
  priceDollars: 17.5,
  description:
    'Collar necklace composed of small and large matte beads with shiny metal spacers.\n\n• Lobster Claw\n\n• 18.5" Length\n\n• 0.6" Width\n\n• 3" Extension\n\n• Nickel and Lead Compliant (Hypoallergenic)',
  tags: [],
  msrpDollars: 44,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:02.351Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
